// DGII Tabla IV — Codificación Unidad de Medida. Confirmed 2026-07-14 directly
// from DGMax/DGII documentation.
const UNIDADES_MEDIDA = [
  { code: 1, abbr: 'BARR', name: 'Barril' },
  { code: 2, abbr: 'BOL', name: 'Bolsa' },
  { code: 3, abbr: 'BOT', name: 'Bote' },
  { code: 4, abbr: 'BULTO', name: 'Bultos' },
  { code: 5, abbr: 'BOTELLA', name: 'Botella' },
  { code: 6, abbr: 'CAJ', name: 'Caja/Cajón' },
  { code: 7, abbr: 'CAJETILLA', name: 'Cajetilla' },
  { code: 8, abbr: 'CM', name: 'Centímetro' },
  { code: 9, abbr: 'CIL', name: 'Cilindro' },
  { code: 10, abbr: 'CONJ', name: 'Conjunto' },
  { code: 11, abbr: 'CONT', name: 'Contenedor' },
  { code: 12, abbr: 'DÍA', name: 'Día' },
  { code: 13, abbr: 'DOC', name: 'Docena' },
  { code: 14, abbr: 'FARD', name: 'Fardo' },
  { code: 15, abbr: 'GL', name: 'Galones' },
  { code: 16, abbr: 'GRAD', name: 'Grado' },
  { code: 17, abbr: 'GR', name: 'Gramo' },
  { code: 18, abbr: 'GRAN', name: 'Granel' },
  { code: 19, abbr: 'HOR', name: 'Hora' },
  { code: 20, abbr: 'HUAC', name: 'Huacal' },
  { code: 21, abbr: 'KG', name: 'Kilogramo' },
  { code: 22, abbr: 'kWh', name: 'Kilovatio Hora' },
  { code: 23, abbr: 'LB', name: 'Libra' },
  { code: 24, abbr: 'LITRO', name: 'Litro' },
  { code: 25, abbr: 'LOT', name: 'Lote' },
  { code: 26, abbr: 'M', name: 'Metro' },
  { code: 27, abbr: 'M2', name: 'Metro Cuadrado' },
  { code: 28, abbr: 'M3', name: 'Metro Cúbico' },
  { code: 29, abbr: 'MMBTU', name: 'Millones de Unidades Térmicas' },
  { code: 30, abbr: 'MIN', name: 'Minuto' },
  { code: 31, abbr: 'PAQ', name: 'Paquete' },
  { code: 32, abbr: 'PAR', name: 'Par' },
  { code: 33, abbr: 'PIE', name: 'Pie' },
  { code: 34, abbr: 'PZA', name: 'Pieza' },
  { code: 35, abbr: 'ROL', name: 'Rollo' },
  { code: 36, abbr: 'SOBR', name: 'Sobre' },
  { code: 37, abbr: 'SEG', name: 'Segundo' },
  { code: 38, abbr: 'TANQUE', name: 'Tanque' },
  { code: 39, abbr: 'TONE', name: 'Tonelada' },
  { code: 40, abbr: 'TUB', name: 'Tubo' },
  { code: 41, abbr: 'YD', name: 'Yarda' },
  { code: 42, abbr: 'YD2', name: 'Yarda cuadrada' },
  { code: 43, abbr: 'UND', name: 'Unidad' },
  { code: 44, abbr: 'EA', name: 'Elemento' },
  { code: 45, abbr: 'MILLAR', name: 'Millar' },
  { code: 46, abbr: 'SAC', name: 'Saco' },
  { code: 47, abbr: 'LAT', name: 'Lata' },
  { code: 48, abbr: 'DIS', name: 'Display' },
  { code: 49, abbr: 'BID', name: 'Bidón' },
  { code: 50, abbr: 'RAC', name: 'Ración' },
  { code: 51, abbr: 'Q', name: 'Quintal' },
  { code: 52, abbr: 'GRT', name: 'Toneladas de registro bruto' },
  { code: 53, abbr: 'P2', name: 'Pie Cuadrado' },
  { code: 54, abbr: 'PAX', name: 'Pasajero' },
  { code: 55, abbr: 'PULG', name: 'Pulgadas' },
  { code: 56, abbr: 'STAY', name: 'Parqueo Barcos En Muelle' },
  { code: 57, abbr: 'BDJ', name: 'Bandeja' },
  { code: 58, abbr: 'HA', name: 'Hectárea' },
  { code: 59, abbr: 'ML', name: 'Mililitro' },
  { code: 60, abbr: 'MG', name: 'Miligramo' },
  { code: 61, abbr: 'OZ', name: 'Onzas' },
  { code: 62, abbr: 'OZT', name: 'Onzas Troy' },
];

export default UNIDADES_MEDIDA;
